import React, { useRef } from "react";
import { Container } from "./styles";

const ModalContainer: React.FC = ({ children }) => {
  const containerRef = useRef<HTMLDivElement | null>(null);

  return <Container ref={containerRef}>{children}</Container>;
};

export default ModalContainer;
